import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class MotiusNoNotificacioFilter extends FilterData {
  somId: number;
  descripcio: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.somId = null;
    this.descripcio = '';

    this.labels['somId'] = this.i18n('Id');
    this.labels['descripcio'] = this.i18n('Descripció');
  }
}
